var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.fila),function(item,index){return _c('item-loader',{key:item.name,attrs:{"item":item,"pausado":_vm.pauseList[index]},on:{"itemCancelado":_vm.itemCancelado,"itemCarregado":_vm.itemCarregado,"erro":_vm.itemFalha}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }